import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { DeclarationJourney } from "@/features/individuals/components/declaration-journey"
import { describing } from "@/lib/subject"
import { fitnessQueries } from "@/queries/fitness"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/"
)({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        individualQueries.detail(params.individualId)
      ),
      context.queryClient.ensureQueryData(
        fitnessQueries.detail(params.individualId, params.assessmentId)
      ),
    ]),
  component: RecordDeclarationPage,
})

/**
 * Keying in a declaration the person made on a signed paper form. Every
 * answer saves as it is entered, so the page can be left and resumed.
 */
function RecordDeclarationPage() {
  const { individualId, assessmentId } = Route.useParams()
  const navigate = useNavigate()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <DeclarationJourney
      individualId={individualId}
      assessmentId={assessmentId}
      subject={describing(individual.fullName)}
      fromSignedForm
      onFinished={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/individuals/$individualId/fitness",
          params: { individualId },
        })
      }
    />
  )
}
